import { ConsultaPadrao } from "../../../components/ConsultaPadrao";
import { model_categoria } from "../../../models";

export const Categoria = () => {
    const columns = [
        { field: 'catid', header: 'Código' },
        { field: 'catdescricao', header: 'Descrição' },        
        { field: 'catativo', header: 'Ativo' },
        { field: 'functions', style: { minWidth: '2rem', width: '2rem' } }
    ];

    return (
        <ConsultaPadrao model={model_categoria} columns={columns} />
    )
}

